// @ts-ignore
import * as Vue from 'vue';
var allVue = Vue;
var gh = allVue.h;
var isV3 = allVue.version && allVue.version[0] === '3';
var inject = allVue.inject;
import { classNames } from '@progress/kendo-vue-common';
import { TimeHeaderCell } from '../../components/TimeHeaderCell';
/** @hidden */
var DayViewRowContentVue2 = {
  name: 'KendoDayViewRowContent',
  props: {
    contentSlot: Object,
    // slot: Object,
    isMaster: Boolean,
    isLast: Boolean,
    timeHeaderCell: [String, Function, Object]
  },
  // @ts-ignore
  setup: !isV3 ? undefined : function () {
    var v3 = !!isV3;
    return {
      v3: v3
    };
  },
  // @ts-ignore
  render: function render(createElement) {
    var h = gh || createElement;
    var contentSlot = this.$props.contentSlot;
    return this.$props.isMaster ? h(TimeHeaderCell, {
      as: this.$props.timeHeaderCell,
      attrs: this.v3 ? undefined : {
        as: this.$props.timeHeaderCell,
        date: contentSlot.zonedStart,
        start: contentSlot.zonedStart,
        end: contentSlot.zonedEnd
      },
      date: contentSlot.zonedStart,
      start: contentSlot.zonedStart,
      end: contentSlot.zonedEnd,
      "class": classNames('k-side-cell', {
        'k-major-cell': !this.$props.isLast
      })
    }) : h("div", {
      "class": 'k-scheduler-cell k-heading-cell k-side-cell'
    });
  }
};
/** @hidden */
var DayViewRowContent = DayViewRowContentVue2;
export { DayViewRowContent, DayViewRowContentVue2 };